// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION = '2.0.0';
export const API_BASE_URL_AUTH = 'https://api-portal.sstmax.com.br/';
export const API_BASE_URL_DOWNLOAD = 'https://up-down.sstmax.com.br/';
export const ENABLE_REDUX_LOGGER = false;
export const API_BASE_URL_SSTMAX = 'https://api-portal.sstmax.com.br/';

export default {};